import React, { FC, HTMLAttributes, memo } from "react";
import Link from "next/link";
import styled from "styled-components";

export type Props = HTMLAttributes<HTMLDivElement> & { isHometownTax: boolean };
const HometownTaxAnnotation: FC<Props> = ({ isHometownTax, ...props }) => {
  return isHometownTax ? (
    <Root {...props}>
      <Text>
        このプロジェクトは地方税法に基づく「ふるさと納税」に対応しています。
        <br />
        <Link href="/lp/animefurusato" passHref>
          <LinkText target="_blank" rel="noreferrer">
            ふるさと納税とは？
          </LinkText>
        </Link>
        <br />
      </Text>
      <Text>※[注意] 住民票登録している自治体にふるさと納税した場合、寄附の返礼品を受け取ることはできません。</Text>
    </Root>
  ) : (
    <></>
  );
};
export default memo(HometownTaxAnnotation);

const Root = styled.div`
  border: 1px solid #fff;
  padding: 10px;
  color: white;
  line-height: 1.428em;
  @media screen and (max-width: 1280px) {
    font-size: 14px;
  }
  @media screen and (min-width: 1281px) {
    font-size: 16px;
  }
`;
const Text = styled.div`
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const LinkText = styled.a`
  color: white;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;
